import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

export interface ValidationAddressModel {
    addressType?: "billing" | "shipping" | "generic";
    address1: string;
    address2: string;
    address3: string;
    address4: string;
    city: string;
    state: string;
    postalCode: string;
    country: string;
}
export interface AddressValidationParameter extends ApiParameter {
    address: ValidationAddressModel;
}

export interface AddressValidationResultModel {
    validationResult: AddressValidationResult;
    properties: string[];
}

export interface AddressValidationResult {
    uri: string;
    address: ValidationAddressModel;
    classification: string;
    clientReferenceId: string;
    state: string;
    countrySupported: boolean;
    zip11Match: boolean;
    suiteRequiredButMissing: boolean;
    invalidSuiteNumber: boolean;
    multipleMatches: boolean;
    postalValidated: boolean;
    generalDelivery: boolean;
    streetRangeValidated: boolean;
    streetValidated: boolean;
    missingOrAmbiguousDirectional: boolean;
    cityStateValidated: boolean;
    resolved: boolean;
    dpv: boolean;
    ziP4Match: boolean;
    validMultiUnit: boolean;
    streetAddress: boolean;
    poBoxOnlyZip: boolean;
    uniqueZip: boolean;
    splitZip: boolean;
    rrConversion: boolean;
    success: boolean;
    unsupported: boolean;
    errors: boolean;
    forceValidation: boolean;
    enforceAtShipToLevel: boolean;
    showValidatedAddressPrompt: boolean;
    addressValidationProvider: string;
    properties: {};
}

const supplyLandUrl = "/api/v1/supplyland";

export const invalidAddressException = "Insite.Core.Exceptions.InvalidAddressException";

export async function validateAddress(parameter: ValidationAddressModel) {
    const apiResponse = await post<ValidationAddressModel, AddressValidationResultModel>(
        `${supplyLandUrl}/validateaddress`,
        parameter,
    );
    return apiResponse;
}
